import PermissionIndex from "@/components/permission/PermissionIndex.vue";
import PermissionAdd from "@/components/permission/PermissionAdd.vue";
import PermissionDetail from "@/components/permission/PermissionDetail.vue";
import PermissionEdit from "@/components/permission/PermissionEdit.vue";

let routesPermissionAccess= [
    {
        path: '',
        meta: {
          title: "List Permission Access",
        },
        name: "PermissionIndex",
        component: PermissionIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Permission Access",
        },
        name: "PermissionAdd",
        component: PermissionAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Permission Access",
        },
        name: "PermissionDetail",
        component: PermissionDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Permission Access",
        },
        name: "PermissionEdit",
        component: PermissionEdit
    },
    
]

export default routesPermissionAccess
  